//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

let promise = null
export default {
  name: 'Confirm',
  props: {
    dialogData: {
      type: Object,
      default() {
        return {
          title: '警告',
          okText: '现在提交',
          cancelText: '稍后处理'
        }
      }
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    callBack(type) {
      this.show = false
      if (type === 'ok') {
        return promise.resolve(type)
      } else {
        return promise.reject(type)
      }
    },
    showConfirm() {
      this.show = true
      return new Promise((resolve, reject) => {
        promise = { resolve, reject }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/confirm.vue